import styled from "styled-components";

export const PoolFormCompanyTableAddFormWrapper = styled.div`
    .ant-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }
    .ant-form-item {
        margin-bottom: 0;
    }
    @media (max-width: 768px) {
        .ant-form {
            flex-direction: column;
            align-items: stretch;
        }
        .ant-form-item {
            margin-right: 0 !important;
            max-width: 100%;
        }
    }
`;

export const PoolFormCompanyTableContainer = styled.div`
    display: flex;
    gap: 16px;
    margin-bottom: 8px;
    align-items: center;
    min-width: 0;
    width: 100%;

    .ant-input-search {
        flex: 1;
        min-width: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: stretch;

        .ant-input-search {
            width: 100%;
            max-width: 100%;
        }

        > .ant-btn {
            width: 100%;
            margin-bottom: 0;
        }
    }
`;
